function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Interface / Shopping_Cart_02"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M4 4H4.3578C4.9895 4 5.30591 4 5.56356 4.11397C5.79072 4.21446 5.98494 4.37623 6.125 4.58138C6.28359 4.81367 6.34086 5.12386 6.45516 5.74303L9.33338 21.3334L23.2291 21.3333C23.8333 21.3333 24.1364 21.3333 24.3867 21.2266C24.6078 21.1322 24.7985 20.9795 24.9401 20.7853C25.1002 20.5656 25.1681 20.2716 25.3037 19.6841L25.3047 19.6799L27.397 10.6133L27.3974 10.6114C27.6031 9.72021 27.7062 9.27354 27.593 8.92318C27.4937 8.61576 27.2847 8.35512 27.0075 8.18923C26.6913 8 26.2344 8 25.3183 8H7.33333M24 28C23.2636 28 22.6667 27.403 22.6667 26.6667C22.6667 25.9303 23.2636 25.3333 24 25.3333C24.7364 25.3333 25.3333 25.9303 25.3333 26.6667C25.3333 27.403 24.7364 28 24 28ZM10.6667 28C9.93029 28 9.33333 27.403 9.33333 26.6667C9.33333 25.9303 9.93029 25.3333 10.6667 25.3333C11.403 25.3333 12 25.9303 12 26.6667C12 27.403 11.403 28 10.6667 28Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart.227765bb.svg";
export { ForwardRef as ReactComponent };